module.exports = __webpack_public_path__ + "img/got_questions_img.bc0846b0.png";